import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../student/store/actions'
import * as EnrollmentActions from '../../enrollment/store/actions';
import {
    Grid, IconButton, Icon, Typography, TextField, TableRow, TableCell, Card, Tooltip,
    CardContent, CardActions, Button, Divider, Table, TableBody, Slide, Paper, SnackbarContent, TableHead
} from '@material-ui/core';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));
const allViews = ["day", "month"]

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-current-time-indicator': {
            display: 'none!important',
        },
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 500,
            fontSize: 14
        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                // ...theme.mixins.border(1)
                display: 'none'
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1),
                overflow: 'auto',
                position: 'static',
            },
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 0,
            padding: '4px 8px',
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },

    },
    addButton: {
        display: 'none'
    }
});

class StudentDashboardNew extends Component {

    constructor(props) {
        super(props);
        const student_id = this.props.auth.user.data.role_info.link_id
        this.props.checkDoesStudentHaveCourses(student_id)
        this.props.getDayEvents(student_id, moment(new Date()).format('YYYY-MM-DD'))
        this.props.getStudentSchedule(student_id, 'all')
        this.props.getNextUnscheduledEvents(student_id, moment(new Date()).format('YYYY-MM-DD'))
        this.props.getEnrollmentCourseList(student_id);
        this.props.getMajorList();
        this.props.getNextScheduledEvent(student_id, moment(new Date()).format('YYYY-MM-DD'));
        this.props.getNextUnscheduledEventWidget(student_id, moment(new Date()).format('YYYY-MM-DD'));
        this.state = {
            ...this.state,
            student_id: student_id,
        }
    }

    state = {
        currentView: 'day',
        date: new Date(),
        displaySlider: true,
        sliderStart: 0,
    }

    onNavigate = (event) => {
        const beginningMonth = this.state.date.getMonth()
        this.setState({ date: event })
        if (event.getMonth() === beginningMonth) {
            this.props.getDayEvents(this.state.student_id, moment(new Date(event)).format('YYYY-MM-DD'))
            this.props.getNextUnscheduledEvents(this.state.student_id, moment(new Date()).format('YYYY-MM-DD'))
        }
        else {
            this.props.getStudentSchedule(this.state.student_id, event)
            this.props.getDayEvents(this.state.student_id, moment(new Date(event)).format('YYYY-MM-DD'))
            this.props.getNextUnscheduledEvents(this.state.student_id, moment(new Date()).format('YYYY-MM-DD'))
        }
    }

    selectSlot = (slotInfo) => {
        this.props.getDayEvents(this.state.student_id, moment(new Date(slotInfo.start)).format('YYYY-MM-DD'))
        this.setState({ date: slotInfo.start, currentView: 'day' })
    }

    onView = (view) => {
        this.state.currentView === 'month' ? this.setState({ currentView: 'day' }) : this.setState({ currentView: 'month' })
        this.props.getDayEvents(this.state.student_id, moment(new Date(this.state.date)).format('YYYY-MM-DD'))
    }

    handleEventSelect = (event) => {
        if (event.allDay) {
            return true
        }
        if (moment() < moment(event.start)) {
            return true
        }
        else {
            return this.props.history.push(`/${event.EventType}/student/${event.company_calendar_event_id}`)
        }

    }


    eventStyleGetter = (event, start, end, isSelected) => {
        switch (event.EventType) {
            case ('fullCourse'): {
                let style = { backgroundColor: event.selected ? 'green' : event.color }
                return { style: style }
            }
            case ('fullModule'): {
                let style = { backgroundColor: event.selected ? '#B10DC9' : '#0074D9' }
                return { style: style }
            }
            case ('fullLesson'): {
                let style = { backgroundColor: event.selected ? '#01FF70' : '#FF851B' }
                return { style: style }
            }
            case ('quiz'): {
                let style = { backgroundColor: event.selected ? '#0074D9' : '#0074D9' }
                return { style: style }
            }
            case ('assignment'): {
                let style = { backgroundColor: event.Color }
                return { style: style }
            }
            default: {
                let style = { backgroundColor: event.selected ? 'green' : '' }
                return { style: style }
            }
        }
    }

    onSlideChange = (e) => {
        this.setState({ sliderStart: e.item })
    }

    render() {
        const { classes, events, dayEvents, theme, nextScheduledEvent } = this.props;
        const slideItems = this.props.courseList
            .filter(c => !c.EnrollmentStatus)
            .map(course => {
                return (
                    <div className="w-full p-16" key={course.company_calendar_course_id}>
                        <Card elevation={1} className="flex flex-col min-h-256">
                            <div
                                className="flex px-24 h-64"
                                style={{
                                    background: course.Color,
                                    color: theme.palette.getContrastText(course.Color),
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography
                                    style={{
                                        color: theme.palette.getContrastText(course.Color),
                                        textAlign: 'center'
                                    }}
                                >
                                    {course.CourseName}
                                </Typography>
                            </div>
                            <CardContent className="flex flex-col flex-1 items-center justify-center">
                                {/* <Typography className="text-center text-16 font-400">{course.CourseName}</Typography> */}
                                {course.Unscheduled === 0 ?
                                    <Typography className="text-center text-13 font-600 mt-4" color="textSecondary">{course.StartDate + ' - ' + course.EndDate}</Typography>
                                    :
                                    <Typography className="text-center text-13 font-600 mt-4" color="textSecondary">{'Self-Paced'}</Typography>
                                }
                                {/* {course.EnrollmentStatus ?
                                <Typography className="text-center text-13 font-600 mt-4" color="textSecondary">{'Already Enrolled'}</Typography>
                                :
                                null
                            } */}

                            </CardContent>
                            <Divider />
                            <CardActions className="justify-center">
                                <Button
                                    className="justify-start px-32"
                                    color={course.EnrollmentStatus ? 'primary' : 'secondary'}
                                    onClick={() => this.props.history.push('/course_enrollment/detail/' + course.company_calendar_course_id)}
                                >
                                    View Course
                            </Button>
                            </CardActions>
                        </Card>
                    </div >
                )
            })

        const todayUnsched = this.props.dayEventsUnscheduled.map(event => {
            return (
                <TableRow>
                    <TableCell>{event.CourseName}</TableCell>
                    <TableCell>{event.title}</TableCell>
                    <TableCell>{event.EventType}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={() => this.props.history.push(`/${event.EventType}/student/${event.company_calendar_event_id}`)}
                        >
                            <Icon>edit</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const selfPacedNextEvents = this.props.nextUnscheduledEvents.filter(e => e.nextEvent.length != 0).map(event => {
            return (
                <TableRow key={event.nextEvent.company_calendar_event_id}>
                    <TableCell>{event.CourseName}</TableCell>
                    <TableCell>{event.nextEvent.EventName}</TableCell>
                    <TableCell>{event.nextEvent.EventType}</TableCell>
                    <TableCell>
                        <IconButton
                            onClick={() => this.props.history.push(`/${event.nextEvent.EventType}/student/${event.nextEvent.company_calendar_event_id}`)}
                        >
                            <Icon>edit</Icon>
                        </IconButton>
                    </TableCell>
                </TableRow>
            )
        })

        const fullDayComponent = ({ event }) => (
            <div>
                <div style={{ fontSize: '12px' }} >{event.title} </div>
                <div style={{ fontSize: '10px' }} >{event.courseName} </div>
            </div>
        )

        const dayEventComponent = ({ event }) => (
            <div>
                {event.title}
            </div>
        )

        const responsive = {
            0: { items: 3 },
            900: { items: 4 },
            1024: { items: 5 },
        }

        const ownPaceContent = (prop) => {
            const { dayEvents, nextUnscheduledEventWidget } = this.props;

            if (!prop) { return null }
            return (

                <Card elevation={1}>
                    <div
                        className="flex px-24 h-64"
                        style={{
                            background: '#202020',
                            color: theme.palette.getContrastText('#202020'),
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <Typography
                            variant='h5'
                            style={{
                                color: theme.palette.getContrastText('#202020'),
                            }}
                        >
                            AT YOUR OWN PACE
                        </Typography>
                    </div>
                    {nextUnscheduledEventWidget.EventStatus === 'none' ?
                        <div
                            className="flex px-24 h-64"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <Typography>
                                No self-paced events to complete
                            </Typography>
                        </div>
                        :
                        <div className="p-16">
                            <div>
                                <span style={{ fontSize: '18px' }}><b>{nextUnscheduledEventWidget.event.CourseName}:</b> {' ' + nextUnscheduledEventWidget.event.EventName}</span>
                                <Button
                                    style={{ backgroundColor: nextUnscheduledEventWidget.ButtonColor, margin: '0px', float: 'right' }}
                                    variant={'contained'}
                                    onClick={() => this.props.history.push(`/${nextUnscheduledEventWidget.event.EventType}/student/${nextUnscheduledEventWidget.event.company_calendar_event_id}`)}
                                >
                                    {nextUnscheduledEventWidget.ButtonText || 0}
                                </Button>
                                <div style={{ clear: 'both' }}></div>
                            </div>
                        </div>
                    }
                </Card>
            )
        }

        const nextScheduledContent = (prop) => {
            if (!prop) { return null }
            const { nextScheduledEvent } = this.props;
            return (
                <Card elevation={1}>
                    <div
                        className="flex px-24 h-64"
                        style={{
                            background: '#202020',
                            color: theme.palette.getContrastText('#202020'),
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <Typography
                            variant='h5'
                            style={{
                                color: theme.palette.getContrastText('#202020'),
                            }}
                        >
                            NEXT ON THE SCHEDULE
                        </Typography>
                    </div>
                    {nextScheduledEvent.EventStatus === 'none' ?
                        <div
                            className="flex px-24 h-64"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <Typography>
                                Scheduled events are up to date!
                            </Typography>
                        </div>
                        :
                        <div className="p-16">
                            <span style={{ fontSize: '18px' }}>
                                <b>{nextScheduledEvent.event.CourseName}</b>: {' ' + nextScheduledEvent.event.EventName}
                            </span>
                            {/* <div > */}
                            <Button
                                style={{ backgroundColor: nextScheduledEvent.ButtonColor, margin: '0px', float: 'right' }}
                                variant={'contained'}
                                onClick={() => this.props.history.push(`/${nextScheduledEvent.event.EventType}/student/${nextScheduledEvent.event.company_calendar_event_id}`)}
                            >
                                {nextScheduledEvent.ButtonText || ''}
                            </Button>
                            <div style={{ clear: 'both' }}></div>
                        </div>
                    }

                </Card>
            )
        }

        const calendarView = (prop) => {
            if (!prop) { return null }
            return (
                <Paper>
                    <BigCalendar
                        popup
                        selectable
                        view={this.state.currentView}
                        className="flex flex-1"
                        events={this.state.currentView === 'month' ? events : dayEvents}
                        views={allViews}
                        showMultiDayTimes
                        defaultDate={new Date()}
                        onSelectSlot={(slotInfo) => this.selectSlot(slotInfo)}
                        date={this.state.date}
                        onNavigate={(event) => this.onNavigate(event)}
                        eventPropGetter={(this.eventStyleGetter)}
                        components={{ event: fullDayComponent, day: { event: dayEventComponent } }}
                        onView={(view) => this.onView(view)}
                        min={new Date(moment().startOf('day').add(6, 'hours'))}
                        max={new Date(moment().startOf('day').add(18, 'hours'))}
                        step={30}
                        onSelectEvent={event => {
                            this.handleEventSelect(event)
                        }}
                    />
                </Paper>
            )
        }

        const selfPacedTable = (prop) => {
            if (!prop) { return null }
            return (
                <Paper>
                    <Typography
                        variant='h4'
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingBottom: '10px',
                            paddingTop: '5px'
                        }}
                    >
                        Continue Self-Paced Courses
                    </Typography>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Course Name</TableCell>
                                <TableCell>Event Name</TableCell>
                                <TableCell>Event Type</TableCell>
                                <TableCell></TableCell>
                            </TableRow>

                        </TableHead>
                        <TableBody>
                            {selfPacedNextEvents}
                        </TableBody>
                    </Table>
                </Paper>
            )
        }

        const dailyToDoTable = (prop) => {
            if (!prop) { return null }
            return (
                <div style={{ paddingBottom: '20px' }}>
                    <Paper>
                        <Typography
                            variant='h4'
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingBottom: '10px',
                                paddingTop: '5px'
                            }}
                        >
                            Daily ToDo's <span style={{ fontSize: '24px', paddingLeft: '14px' }}>{moment(this.state.date).format('dddd MMM DD')}</span> 
                    </Typography>
                        <Table>
                            <TableHead>
                                <TableCell>Course Name</TableCell>
                                <TableCell>Event Name</TableCell>
                                <TableCell>Event Type</TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {todayUnsched}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>

            )
        }

        return (
            <div className='p-16' >
                <div className={classes.root}>
                    <Grid container spacing={16}>
                        <Grid item xs={12}>
                            <Typography
                                variant='h4'
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                COURSES AVAILABLE FOR ENROLLMENT
                            </Typography>
                            {/* <Slide direction="up" in={this.state.displaySlider} mountOnEnter unmountOnExit> */}
                            <div>
                                <div style={{ width: '5%', float: 'left', paddingTop: '100px' }}>
                                    <IconButton
                                        onClick={() => this.Carousel._slidePrev()}

                                    >
                                        <Icon style={{ fontSize: '54px' }}>keyboard_arrow_left</Icon>
                                    </IconButton>
                                </div>
                                <div style={{ width: '90%', float: 'left' }}>
                                    <AliceCarousel
                                        startIndex={this.state.sliderStart}
                                        responsive={responsive}
                                        dotsDisabled
                                        buttonsDisabled={true}
                                        ref={(el) => (this.Carousel = el)}
                                        onSlideChanged={(e) => this.onSlideChange(e)}
                                    >
                                        {slideItems}
                                    </AliceCarousel>
                                </div>
                                <div style={{ width: '5%', float: 'left', paddingTop: '100px' }}>
                                    <IconButton onClick={() => this.Carousel._slideNext()} ><Icon style={{ fontSize: '54px', }}>keyboard_arrow_right</Icon>
                                    </IconButton>
                                </div>
                            </div>
                            {/* </Slide> */}
                        </Grid>
                        <Grid item xs={6}>
                            {nextScheduledContent(this.props.doesStudentHaveCourses)}
                        </Grid>
                        <Grid item xs={6}>
                            {ownPaceContent(this.props.doesStudentHaveCourses)}
                        </Grid>
                        <Grid item xs={6} style={{ width: '90%', paddingTop: '20px' }}>
                            {calendarView(this.props.doesStudentHaveCourses)}
                        </Grid>
                        <Grid item xs={6} style={{ paddingTop: '20px' }}>
                            {dailyToDoTable(this.props.dayEventsUnscheduled.length > 0)}
                            {selfPacedTable(this.props.nextUnscheduledEvents.filter(e => e.nextEvent.length != 0).length > 0)}
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentSchedule: Actions.getStudentSchedule,
        getDayEvents: Actions.getDayEvents,
        getNextUnscheduledEvents: Actions.getNextUnscheduledEvents,
        getNextScheduledEvent: Actions.getNextScheduledEvent,
        getNextUnscheduledEventWidget: Actions.getNextUnscheduledEventWidget,
        checkDoesStudentHaveCourses: Actions.checkDoesStudentHaveCourses,
        getEnrollmentCourseList: EnrollmentActions.getEnrollmentCourseList,
        setSearchText: EnrollmentActions.setSearchText,
        setMajorFilter: EnrollmentActions.setMajorFilter,
        getMajorList: EnrollmentActions.getMajorList,
        setCoursePopoverAnchor: EnrollmentActions.setCoursePopoverAnchor,
        submitStudentEnrollment: EnrollmentActions.submitStudentEnrollment,
        removeStudentEnrollment: EnrollmentActions.removeStudentEnrollment,

    }, dispatch);
}

function mapStateToProps({ studentApp, auth, enrollmentApp }) {
    return {
        events: studentApp.students.events,
        dayEvents: studentApp.students.dayEvents,
        nextUnscheduledEvents: studentApp.students.nextUnscheduledEvents,
        dayEventsUnscheduled: studentApp.students.dayEventsUnscheduled,
        nextScheduledEvent: studentApp.students.nextScheduledEvent,
        nextUnscheduledEventWidget: studentApp.students.nextUnscheduledEventWidget,
        doesStudentHaveCourses: studentApp.students.doesStudentHaveCourses,
        courseList: enrollmentApp.enrollment.courseList,
        searchText: enrollmentApp.enrollment.searchText,
        majorList: enrollmentApp.enrollment.majorList,
        majorFilter: enrollmentApp.enrollment.majorFilter,
        auth
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(StudentDashboardNew)));


// WEBPACK FOOTER //
// src/main/content/dashboard/components/StudentDashboardNew.js